import TYPES from '@/modules/shared/types';

// Domain
import {
  CustomerContractedInvestmentProductsRepository,
} from '@/modules/flagship/customer-contracted-investment-products/domain/repositories/customer-contracted-investment-products-repository';
import {
  CustomerContractedInvestmentProductsEntity,
} from '@/modules/flagship/customer-contracted-investment-products/domain/entities/customer-contracted-investment-products-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class CustomerContractedInvestmentProductsHttpRepository
implements CustomerContractedInvestmentProductsRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/customer-contracted-investment-products/`;

  get(): Promise<CustomerContractedInvestmentProductsEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ success, data, error }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(error));
              }
            });
        })
        .catch(reject);
    });
  }
}
